class CookieConsent extends HTMLElement {
	constructor() {
		super();  

        this.cookie = this;

		if (this.getCookie('cookie-consent') === ''){
            // Delay cookie bar so it does not compete with mobile LCP/FCP
            const reveal = () => {
                this.cookie.style.display = "block";

                if(this.cookie.classList.contains('full-width')){
                    var cookieHeight = this.cookie.offsetHeight;

                    if(cookieHeight > 0){
                        document.body.style.paddingBottom = cookieHeight + "px";
                    }

                    var w = window.innerWidth;

                    window.addEventListener('resize', () => {
                        if (window.innerWidth == w) {
                            return
                        }

                        w = window.innerWidth;

                        var cookieHeight = this.cookie.offsetHeight;

                        if(cookieHeight > 0){
                            document.body.style.paddingBottom = cookieHeight + "px";
                        }
                    });
                }
            };

            const scheduleReveal = () => {
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(() => setTimeout(reveal, 2500), { timeout: 4000 });
                } else {
                    setTimeout(reveal, 3000);
                }
            };

            if (document.readyState === 'complete') {
                scheduleReveal();
            } else {
                window.addEventListener('load', scheduleReveal, { once: true });
            }
		} else {
			this.remove();
		}

		const acceptBtn = this.querySelector('[data-accept-cookie]');
		if (acceptBtn) {
			acceptBtn.addEventListener(
				'click',
				this.setClosePopup.bind(this)
			);
		}
	}

	setCookie(cname, cvalue, exdays) {
  		const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(event, expiresDate = 1) {
        event.preventDefault();
        
        this.setCookie('cookie-consent', 'closed', expiresDate);
        this.cookie.remove();

        if(this.cookie.classList.contains('full-width')){
            document.body.style.paddingBottom = "0px";
        }
    }
}

customElements.define('cookie-consent', CookieConsent);